import { Col, Form, Input, Row, Select, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import "./createnewservice.css";
import FormService from "../../../components/generic/formbuilder/networkservice/FormService";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { useRecoilValue } from "recoil";
import { currentConfiguration } from "../../../service/memory/recoil/configurationstore";
import SecondaryButton from "../../../components/generic/buttons/SecondaryButton";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";

const CreateNewService = ({ initialValues, addService, selectedServices, setSelectedServices, closeModal, isEditServicesLoading, addServiceOption }) => {
	const formService = new FormService();
	const [allFormsData, setAllFormsData] = useState([]);
	const initialConfigValues = initialValues?.configurationValue && JSON.parse(initialValues?.configurationValue);
	const organizationIdentifier = useGetOrgIdentifier();
	const formInitialValues =
		{
			...initialValues,
			templateCode: initialConfigValues?.templateCode || initialConfigValues?.templatecode,
			coordinatorForm: initialConfigValues?.coordinatorFormTemplateCode,
			includeInVolunteerHours: initialConfigValues?.includeInVolunteerHours,
			isCoordinatorFormRequired: initialConfigValues?.isCoordinatorFormRequired
		} || {};
	const configuration = useRecoilValue(currentConfiguration);

	const getForms = async () => {
		let allForms = [];
		const forms = await formService.getAllFormMetaData(organizationIdentifier, ["Publish"]);
		if (forms.data) {
			for (let form of forms.data) {
				allForms.push(form);
			}
		}
		setAllFormsData(allForms);
	};

	const options = allFormsData.map((form) => ({
		value: form.templateCode,
		label: form.title,
	}));

	const createService = async (values) => {
		if (typeof values?.title === "string") {
			values = { ...values, title: values.title.trim() };
		}
		if (values?.includeInVolunteerHours === undefined) {
			values = { ...values, includeInVolunteerHours: false };
		}
		
		if (addServiceOption === "Edit Service") {
			const payload = {
				configurationKey: initialValues?.configurationKey,
				configurationValue: JSON.stringify({ templateCode: values.templateCode, includeInVolunteerHours: values.includeInVolunteerHours }),
			};
			await executeIntent(IntentType.ADD_CONFIGURATION, payload, {
				organizationIdentifier: organizationIdentifier,
			});

			const serviceIndex = selectedServices.findIndex((item) => item.title === initialValues?.title);
			const updatedSelectedService = selectedServices.map(service =>
				service.title === initialValues?.title
					? { ...service, title: values.title}
					: service
			);
			setSelectedServices([...updatedSelectedService])
			addService(updatedSelectedService, serviceIndex, "edit service");
		} else {
			const serviceKey = `niramaya.forms.${uuidv4()}`;
			const payload = {
				configurationKey: serviceKey,
				configurationValue: JSON.stringify({ templateCode: values.templateCode, includeInVolunteerHours: values.includeInVolunteerHours }),
			};
			await executeIntent(IntentType.ADD_CONFIGURATION, payload, {
				organizationIdentifier: organizationIdentifier,
			});

			const service = { title: values.title, serviceKey: serviceKey, serviceIdentifier: uuidv4() };
			setSelectedServices((items) => [...items, service]);
			addService([...selectedServices, service], "", "create service");
		}
		closeModal();
	};

	useEffect(() => {
		getForms();
	}, [configuration]);

	return (
		<>
			<div>
				{isEditServicesLoading ? (
					<Spin size="medium" className="d-flex justify-content-center m-auto" />
				) : (
					<Form initialValues={formInitialValues} layout="vertical" onFinish={createService} className="createnewservice-form">
						<Form.Item
							name="title"
							rules={[
								{
									required: true,
									message: "Service Name is required",
								},
							]}
						>
							<Input placeholder="Enter Service Name" />
						</Form.Item>
						<Form.Item
							label="Select form to be associated with this service"
							name="templateCode"
							rules={[
								{
									required: true,
									message: "Please select appropriate form",
								},
							]}
						>
							<Select
								allowClear
								placeholder="Select Form"
								showSearch
								optionFilterProp="children"
								filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
								options={options}
								listHeight={150}
								filterSort={(optionA, optionB) =>
									(optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
								}
							/>
						</Form.Item>

						{/* <Form.Item name="includeInVolunteerHours" valuePropName="checked">
							<Checkbox>Include this service in volunteering hours</Checkbox>
						</Form.Item> */}
						<Row>
							<Col span={24} style={{ textAlign: "right" }}>
								<Form.Item className="createnewservice-form-bottom-buttons">
									<Space size={8}>
										<SecondaryButton buttonText="Cancel" handleOnClick={closeModal}/>
										<PrimaryButton buttonText={addServiceOption} htmlType="submit"/>
									</Space>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				)}
			</div>
		</>
	);
};

export default CreateNewService;
